import axios from "./axios";

/**
 * Public company announcements ("Offentlig på nettsiden") from Promang.
 * GET /api/v1/webpage/announcements — company resolved from the app's
 * own OAuth application token (same mechanism as fetchPublicJobOpenings).
 */
export async function fetchPublicAnnouncements() {
  return axios({
    method: "get",
    url: "/webpage/announcements",
  })
    .then((response) => response.data)
    .catch((error) => error.response?.data || { error: "Failed to fetch announcements" });
}
